import { useState } from 'react'
import { useMount } from 'react-use'

const EXTENSION_ID = 'amjaoklkeffceamacmpblhhhfajdoihl'

type UseDisplayChromeExtensionCtaButton = () => boolean
const useDisplayChromeExtensionCtaButton: UseDisplayChromeExtensionCtaButton =
  () => {
    const [chromium, setChromium] = useState(false)
    const [installed, setInstalled] = useState(false)
    const displayButton = chromium && !installed

    useMount(() => {
      try {
        if (chrome) {
          setChromium(true)
        }

        chrome.runtime?.sendMessage(
          EXTENSION_ID,
          'isExtensionInstalled',
          (response?: { installed: boolean }) => {
            if (response?.installed) {
              setInstalled(true)
            }
          },
        )
      } catch (error) {
        setInstalled(false)
        console.error(error)
      }
    })

    return displayButton
  }

export default useDisplayChromeExtensionCtaButton
